import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/primeng';
import { CampaignService } from '../../../../services/campaign/campaign.service';
import { Campaign } from '../campaign';


@Component({
  selector: 'campaign-steps',
  templateUrl: 'campaign-steps.html',
  styles: ['::ng-deep a.ui-menuitem-link.ng-star-inserted {white-space: nowrap;}']
})

export class CampaignStepsComponent {

  @Input() step: number;
  @Input() campaign: Campaign;

  public items: MenuItem[];

  constructor(private translate: TranslateService, private campaignService: CampaignService) { }

  ngOnInit() {
    this.translate.get(['campaign']).subscribe((res) => {
      this.items = [
        { label: res.campaign.step1 },
        { label: res.campaign.step2 },
        { label: res.campaign.step3 },
        { label: res.campaign.step4 },
        { label: res.campaign.step5 }
      ];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/steps/campaign-steps.component.ts